/**
 * The business day convention used for adjusting dates. The value defined here applies to all adjustable dates in the instrument unless specifically overridden.
 * - Tag: 40921
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const BusinessDayConvention = Object.freeze({
    NotApplicable: 0,
    /** None (current day) */
    None: 1,
    FollowingDay: 2,
    FloatingRateNote: 3,
    ModifiedFollowingDay: 4,
    PrecedingDay: 5,
    ModifiedPrecedingDay: 6,
    NearestDay: 7,
} as const);

type BusinessDayConvention = (typeof BusinessDayConvention)[keyof typeof BusinessDayConvention];
